<template>
  <div class="header">
    <div class="back-button" @click="gotoTaskList()">
      <img src="/img/icons/back_arrow.png" />
    </div>
    <div class="breadcrumb-outer">
      <span id="gotoProductList" @click="gotoProductList">
        {{ productListText }}
      </span>
      <b-tooltip
        :label="breadcrumbsPublisher"
        position="is-bottom"
        :triggers="['hover', 'click']"
        :multilined="true"
      >
        <div class="breadcrumb" @click="gotoTaskList()">
          <template v-if="this.$route.name.includes('editor')">
            <div class="path">
              <pre> > </pre>
            </div>
          </template>
          <template v-else>
            &nbsp;>
            {{ breadcrumbsPublisher }}
          </template>
        </div>
      </b-tooltip>
      <div :class="'breadcrumb'">&nbsp;> {{ $t('work_instructions') }}</div>
    </div>

    <div class="buttons">
      <template v-if="packages.length > 0">
        <b-dropdown aria-role="list">
          <template #trigger>
            <b-button
              :label="
                currentPackage
                  ? currentPackage.title
                  : $t('select_work_instruction_package')
              "
              expanded
              type="is-primary"
              icon-right="menu-down"
            />
          </template>

          <b-dropdown-item
            aria-role="listitem"
            v-for="wiPackage in packages"
            :key="wiPackage._id"
            :value="wiPackage._id"
            @click="onPackageChange(wiPackage)"
          >
            <h3>{{ wiPackage.title }}</h3>
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <b-button
        v-if="currentPackage && !isInspectorRoute"
        type="is-primary"
        icon-left="microsoft-excel"
        @click="onExportPackage"
      >
        Export WI
      </b-button>

      <b-button
        v-if="!isInspectorRoute"
        type="is-info"
        @click="onAddWorkInstructionPackage"
      >
        {{ $t('add_work_instruction') }}
      </b-button>
    </div>
  </div>
</template>
<script>
import JobViewMixin from '../../../mixins/Shared/JobViewMixin';
import {
  GET_WORK_INSTRUCTION_PACKAGES,
  CURRENT_WORK_INSTRUCTION_PACKAGE,
} from '../../../store/workInstruction/getters/getterTypes';
import { LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE } from '../../../store/workInstruction/mutations/mutationTypes';

export default {
  name: 'WorkInstructionsHeader',
  mixins: [JobViewMixin],
  computed: {
    packages() {
      return this.$store.getters[GET_WORK_INSTRUCTION_PACKAGES];
    },

    currentPackage() {
      return this.$store.getters[CURRENT_WORK_INSTRUCTION_PACKAGE];
    },
    isInspectorRoute() {
      return this.$route.name.includes('inspector');
    },

    productListText() {
      return this.$route.name.includes('editor')
        ? this.$t('product_template_list')
        : this.$t('work_order_list');
    },

    breadcrumbsPublisher() {
      const parts = [
        this.currentJob?.title,
        this.currentJob?.customerInfoText,
        this.currentJob?.projectInfoText,
        this.currentJob?.serialNumber,
        this.currentJob?.workOrderNumber,
      ].filter(Boolean);

      return parts.join(' / ');
    },
  },

  methods: {
    onPackageChange(event) {
      const selectedPackage = this.packages.find(
        (pkg) => pkg._id === event._id
      );
      this.$store.commit(
        LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE,
        selectedPackage || null
      );
    },

    gotoProductList() {
      this.isLoading = true;
      if (this.$route.name.includes('editor')) {
        this.$router.push({
          name: 'editor-list',
        });
      } else if (this.$route.name.includes('inspector')) {
        this.$router.push({
          name: 'inspector-list',
        });
      } else if (this.$route.name.includes('publisher')) {
        this.$router.push({
          name: 'publisher-list',
        });
      } else {
        this.$router.push({
          name: 'report-list',
        });
      }
    },
    gotoTaskList() {
      if (this.$route.name.includes('editor')) {
        this.$router.push({
          name: 'editor-tasks',
          params: { id: this.currentJob._id },
        });
      } else if (this.$route.name.includes('inspector')) {
        this.$router.push({
          name: 'inspector-tasks',
          params: { id: this.currentJob._id },
        });
      } else {
        this.$router.push({
          name: 'publisher-tasks',
          params: { id: this.currentJob._id },
        });
      }
    },
    onAddWorkInstructionPackage() {
      this.$emit('onAdd');
    },
    onExportPackage() {
      this.$emit('onExport');
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 2;
  font-family: 'Siemens Sans';
  display: inline-flex;
  position: relative;
  width: 100%;
  height: 50px;
  background-color: #fafafa;
  font-size: 18px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  color: #333;
  .back-button {
    display: inline-flex;
    width: 80px;
    height: 100%;
    cursor: pointer;
    img {
      width: 25px;
      margin: auto;
      &:hover {
        filter: brightness(0%);
      }
    }
  }

  .breadcrumb-outer {
    flex: 1 1 auto;
    display: inline-flex;
  }

  #gotoProductList,
  .breadcrumb {
    max-height: 50px;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    .breadcrumb-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .breadcrumb-text-external-user {
      max-width: 600px;
      margin-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  #gotoProductList {
    color: #ccc;
    min-width: 90px;
    &:hover {
      color: inherit;
      cursor: pointer;
    }
  }

  .path {
    display: inline-flex;
  }
}
.buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 10px;
}
.dropdown {
  margin-top: 9px;
}
</style>
